'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Pattern;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Pattern(_ref) {
  var id = _ref.id,
      width = _ref.width,
      height = _ref.height,
      children = _ref.children;

  return _react2.default.createElement(
    'defs',
    null,
    _react2.default.createElement(
      'pattern',
      { id: id, width: width, height: height, patternUnits: 'userSpaceOnUse' },
      children
    )
  );
}

Pattern.propTypes = {
  id: _propTypes2.default.string.isRequired,
  width: _propTypes2.default.number.isRequired,
  height: _propTypes2.default.number.isRequired,
  children: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.node), _propTypes2.default.node]).isRequired
};